// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"component-breadcrumb"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M14 12L9.49999 7.5L3 7.5L3 16.5L9.5 16.5L14 12Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M14 12L9.49999 7.5L3 7.5L3 16.5L9.5 16.5L14 12Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16 7.5L20.5 12L16 16.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-component-breadcrumb')
export default class ComponentBreadcrumbIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-breadcrumb',
    }
  }
}
